import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 78 78"
		fill="none"
		{...props}
	>
		<path
			stroke="#ffc107"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={4}
			d="M14.625 75.875h48.75c6.904 0 12.5-5.596 12.5-12.5v-48.75c0-6.904-5.596-12.5-12.5-12.5h-48.75c-6.904 0-12.5 5.596-12.5 12.5v48.75c0 6.904 5.596 12.5 12.5 12.5Z"
		/>
		<path
			stroke="#ffc107"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={4}
			d="M39 64c-13.807 0-25-11.193-25-25s11.193-25 25-25 25 11.193 25 25-11.193 25-25 25ZM39 14v12.5M39 51.5V64"
		/>
		<circle
			cx={3.125}
			cy={3.125}
			r={3.125}
			fill="#ffc107"
			transform="matrix(-1 0 0 1 54.625 35.875)"
		/>
		<circle
			cx={3.125}
			cy={3.125}
			r={3.125}
			fill="#ffc107"
			transform="matrix(-1 0 0 1 29.625 35.875)"
		/>
	</svg>
);
export default SvgComponent;
